<template>
  <div class="">
    
      <!-- <div class="card route-card" 
        style="margin-bottom:35px; margin-left:auto; margin-right:auto; padding:30px; 
        background-position: center center; background-size: cover;"
        :style="routeObj.thumbnail ? { backgroundImage: `url(${routeObj.thumbnail})`} : ''"
      >  -->
      <router-link v-bind:to="'/' + 'routes' + '/' + encodeURIComponent(routeObj.display_name)">
      <div class="card route-card" 
        style="margin-bottom:40px; margin-left:auto; margin-right:auto; padding:30px;  background-blend-mode:overlay; 
        background-position: center center, center center; background-size: cover, cover;"
        
        :style="thumbnail ? 
          {
            
            background: 'url(\'' + thumbnail + '\') rgba(255,255,255,0.8)',
            backgroundPosition: 'center center, center center',
            backgroundSize: 'cover, cover',
            backgroundRepeat: 'no-repeat, no-repeat'
            } 
            : 
            ''"
      > 
      <!-- <div style="width: 100%; height: 100%; background-size: cover; display: inline; position: absolute; left: 0; top: 0; background-position: center; opacity: 0.1;"
        :style="routeObj.thumbnail ? { backgroundImage: `url(${routeObj.thumbnail})`} : ''"
      ></div> -->
      <!-- <div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; background-color:white; opacity: 0.5;"
        
      ></div> -->
      <!-- <pre>{{encodeURIComponent(routeObj.display_name)}}</pre> -->
        
        
          <div class="columns  " style="">

            <div class='column is-9-desktop is-full-mobile'>
              <div class="columns ">
                  <div class="column has-text-left is-9-desktop is-full-mobile">
                      <router-link class="is-4 is-5-mobile title is-size-4 is-size-5-mobile" style="display:inline-block; margin-bottom:0px" v-bind:to="'/' + 'routes' + '/' + encodeURIComponent(routeObj.display_name)">{{routeObj.display_name}}</router-link>

                      <!-- <span v-if="(routeObj.touring || routeObj.bikepacking)"> -->
                      <div>
                        
                          <b-tag v-if="routeObj.touring" class="tag is-white" >touring</b-tag>
                          <b-tag v-if="routeObj.bikepacking" class="tag is-white" >bikepacking</b-tag>
                          <b-tag v-if="routeObj.road" class="tag is-white" >road</b-tag>
                          <b-tag v-if="routeObj.gravel" class="tag is-white" >gravel</b-tag>
                          <b-tag v-if="routeObj.singletrack" class="tag is-white" >singletrack</b-tag>
                          <b-tag v-if="routeObj.railtrail" class="tag is-white" >rail trail</b-tag>
                          <b-tag v-if="routeObj.bikepath" class="tag is-white" >bike path</b-tag>
                          
                      </div>
                      <!-- <span v-if="routeObj.length">{{routeObj.length}}  </span> -->
                      <!-- </span> -->

                  </div>
                  <div class='column is-3-desktop is-full-mobile'>
                    <div class="columns has-text-center-desktop has-text-left-mobile is-mobile">
                      <div class="column  is-6-mobile is-4-desktop">
                            <div class="small-label">Posts</div>
                            <p class="is-size-6 is-size-7-mobile">{{routeObj.post_count}}</p>
                        </div>
                        <div class="column  is-6-mobile is-8-desktop" >
                            <div class="small-label" v-if="routeObj.length">Length</div>
                            <p class="is-size-6 is-size-7-mobile" v-if="routeObj.length">{{routeObj.length}}</p>
                        </div>
                    </div>
                  </div>
              </div>
            </div>

              <div class="column is-3-desktop has-text-center-desktop has-text-left-mobile">
                  <div v-if="routeObj.continent || routeObj.countries" class="small-label">Place</div>
                  <p v-if="!routeObj.countries && routeObj.continent" class="is-size-6 is-size-7-mobile">{{routeObj.continent}}</p>
                  <p v-if="routeObj.countries" class="is-size-6 is-size-7-mobile">{{displayCountries(routeObj.countries)}}</p>
                  <p style="font-weight:normal" v-if="routeObj.us_states && Array.isArray(routeObj.us_states)" class="is-size-6 is-size-7-mobile">{{routeObj.us_states.join(", ")}}</p>
              </div>
              
              
              <!-- <div class="column is-4-desktop">
                <div class="columns is-mobile">
                  
                  <div class="column is-5-desktop">
                      <div v-if="routeObj.continent" class="small-label">Continent</div>
                      <p class="is-size-6 is-size-7-mobile">{{routeObj.continent}}</p>
                  </div>
                  <div class="column is-7-desktop">
                      <div v-if="routeObj.countries" class="small-label">Country</div>
                      <p v-if="routeObj.countries" class="is-size-6 is-size-7-mobile">{{displayCountries(routeObj.countries)}}</p>
                      
                      <p style="font-weight:normal" v-if="routeObj.us_states && Array.isArray(routeObj.us_states)" class="is-size-6 is-size-7-mobile">{{routeObj.us_states.join(", ")}}</p>
                  </div>
                </div>
              </div> -->

          </div>


          <!-- <p>{{getImage(routeObj.display_name)}}</p> -->
          
      </div>
  </router-link>
  </div>
</template>

<script>
export default {
  name: 'RouteRow',
  props: ['routeObj', 'teststr'],
  data () {
    return {
      thumbnail: ""
    }
  },
  methods: {
    
    displayCountries(countryArray) {
        var resultStr = "";
        if (countryArray.length > 0) {
            resultStr = this.$countrymap[countryArray[0]];
        }
        if (countryArray.length > 1) {
            resultStr += ', ' + this.$countrymap[countryArray[1]];
        }
        if (countryArray.length > 2) {
            resultStr += ', ' + (countryArray.length - 2).toString() + ' others';
        }
       
        return resultStr;
      },
  },
  mounted() {
    if ( this.routeObj.thumbnail ) {
      this.thumbnail = this.routeObj.thumbnail;
    } else {
      var that = this;
      that.$db.collection("pages").where('routes', 'array-contains', that.routeObj.display_name).orderBy("year", "desc").orderBy("added", "desc").limit(1).get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              // console.log(doc.data());
                // doc.data() is never undefined for query doc snapshots
                that.thumbnail = doc.data().image;
            
            });
          })
          .catch(function(error) {
              console.log("Error getting thumbnail for country: " + that.routeObj.url_path, error);
              that.loading = false;
          })
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .route-card  {
    color:black;
    font-weight:bold;
    border: 5px solid white;
    /* color: white !important; */
  }
  /* .route-card .title {
    color:white !important;
    margin-bottom: 10px !important;
  } */
  .route-card {
    background-position: center center, center center; 
    background-size: cover, cover;
    max-width: 1000px;
  }
  .route-card .tag {
    margin-bottom:5px;
  }
  /* .route-card:before {
  content: "";
  position: absolute;
  left: 0; right: 0;
  top: 0; bottom: 0;
  background: rgba(255, 255, 255, 0.5);
} */
</style>


// WEBPACK FOOTER //
// src/components/RouteRow.vue